import { z } from 'zod';
import { ROLES } from '../dominio.js';
import { TIPOS_DOCUMENTO } from './validacion.js';
import { correo, uuid } from './comunes.js';
export const credenciales = z.object({
    correo,
    password: z.string().min(8, 'La contraseña debe tener al menos 8 caracteres').max(200),
});
/**
 * Política de contraseñas. Deliberadamente moderada: exigir símbolos y mayúsculas
 * empuja a la gente a apuntarlas en un papel.
 *
 * Ocho caracteres con letras y números, decidido el 01/09/2026. Antes eran doce,
 * y el mínimo al iniciar sesión ya era ocho: las dos reglas no coincidían.
 *
 * Lo que hace defendible ese número no es la longitud sino `fn_login_bloqueado()`
 * (migración 012): cinco intentos fallidos por correo cada quince minutos, y
 * veinte por dirección IP. Vive en la base, así que sigue activo aunque la
 * aplicación falle. **Si alguien afloja ese bloqueo, este mínimo se queda corto.**
 */
export const PASSWORD_MIN = 8;
export const passwordNueva = z
    .string()
    .min(PASSWORD_MIN, `La contraseña debe tener al menos ${PASSWORD_MIN} caracteres`)
    .max(200)
    .refine((v) => /[a-zA-Z]/.test(v) && /\d/.test(v), 'Debe combinar letras y números');
export const cambioPassword = z
    .object({
    actual: z.string().min(1, 'Ingrese su contraseña actual').max(200),
    nueva: passwordNueva,
})
    .refine((v) => v.actual !== v.nueva, {
    path: ['nueva'],
    message: 'La nueva contraseña debe ser distinta de la actual',
});
/** Lo que el frontend sabe del usuario. Determina qué se muestra, no qué se permite. */
export const usuarioSesion = z.object({
    id: uuid,
    nombres: z.string(),
    apellidos: z.string(),
    correo: z.string(),
    cargo: z.string().nullable(),
    rol: z.enum(ROLES),
    puedeEmitir: z.boolean(),
    puedeTransicionar: z.boolean(),
    /**
     * Sobre qué tipos de documento decide este rol. `puedeTransicionar` solo
     * dice si decide sobre alguno; esto dice sobre cuáles, para no ofrecer un
     * botón que la base va a rechazar.
     */
    tiposQueDecide: z.array(z.enum(TIPOS_DOCUMENTO)),
    /** Mientras sea true, la aplicación solo deja cambiar la contraseña. */
    debeCambiarPassword: z.boolean(),
});
//# sourceMappingURL=auth.js.map